"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var Auth_1 = require("./Auth");
var Logger_1 = require("./Logger");
function Api(_a) {
    var _b = _a.baseURL, baseURL = _b === void 0 ? "" : _b, _c = _a.apiKey, apiKey = _c === void 0 ? "" : _c;
    if (!apiKey || !baseURL) {
        throw Error("API config must have baseUrl or apiKey defined");
    }
    // create instance
    var instance = axios_1.default.create({
        baseURL: baseURL,
        headers: {
            "x-api-key": apiKey,
        },
    });
    /* interceptors */
    // log request interceptor
    instance.interceptors.request.use(function (config) {
        var tokenConfig = config;
        var token = Auth_1.AuthStore.getAccessToken();
        Logger_1.logInfo("Api: ", "adding auth header");
        if (tokenConfig.token && token) {
            tokenConfig.headers.Authorization = "Bearer " + token;
        }
        return tokenConfig;
    }, function (error) {
        Logger_1.logError(error);
        return Promise.reject(error);
    });
    // log and determine auth token status 403, store.dispatch(signout())
    instance.interceptors.response.use(function (res) {
        Logger_1.logDebug("res: ", res.config.url + ", " + res.status + ", " + res.statusText);
        return res && res.data;
    }, function (error) {
        Logger_1.logError(error);
        return Promise.reject(error);
    });
    return instance;
}
exports.Api = Api;
//# sourceMappingURL=Api.js.map